import React from 'react';
import { Link } from 'gatsby';
import { GatsbyImage } from 'gatsby-plugin-image';

import Layout from '../components/layout';
import Head from '../components/head';

import styles from './listpage.module.scss';

const GalleryPage = ({
  pageContext: { vehicles },
}) => {
  return (
    <Layout>
      <Head title="Hollingdean Parking Gallery" />

      <main className={styles.listpage}>
        <ul className={styles.grid}>
          {vehicles.map(
            (
              {
                make,
                model,
                colour,
                numberPlate,
                gridImage: {
                  optimizedLocalFile: {
                    childImageSharp: { gatsbyImageData },
                  },
                },
              },
              i
            ) => {
              return (
                <li key={`allVehicles-${i}`} className={styles.item}>
                  <Link
                    to={`/gallery/${numberPlate
                      .replace(' ', '-')
                      .toLowerCase()}/`}
                    className={styles.link}
                    aria-label={`View ${numberPlate}, a ${colour} ${make} ${model} parked in Hollingdean`}
                  >
                    <GatsbyImage
                      image={gatsbyImageData}
                      alt={`${numberPlate}, a ${colour} ${make} ${model} parked in Hollingdean`}
                      placholder="dominantColor"
                      loading="lazy"
                    />
                    <h2 className={styles.numberplate}>{numberPlate}</h2>
                  </Link>
                </li>
              );
            }
          )}
        </ul>
      </main>
    </Layout>
  );
};

export default GalleryPage;
